import { Typography } from "@mui/material";

import { dateToStringLong } from "../utils/dateTime";

export default function PrintFooter() {
  return (
    <Typography variant="subtitle2">
      Дата и час на справката: {dateToStringLong(new Date())}
      <br />©{new Date().getFullYear()} Нотариална камара на Република България
    </Typography>
  );
}
